import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";

export function mapData(
  dataTopX: IGenericAggregateResponse,
  dataAll: IGenericAggregateResponse,
  top: number
): any | undefined {
  if (
    (dataTopX.aggregates && dataTopX.aggregates.length === 0) ||
    (dataAll.aggregates && dataAll.aggregates.length === 0)
  ) {
    return undefined;
  }

  const pieData: any = [];
  const kpiPieData: any = [];
  const ytdTopX = calculateSCForTop(dataTopX);
  const YtdAll = calculateSCForAll(dataAll);
  const ytdOthers = Math.abs(YtdAll - ytdTopX);

  kpiPieData.push({
    name: `Top ${top} clients`,
    y: ytdTopX,
  });
  kpiPieData.push({ name: "Other clients", y: ytdOthers });

  pieData[0] = {
    colorByPoint: true,
    data: kpiPieData,
    name: "Client concentration",
  };
  return { data: pieData };
}

function calculateSCForTop(dataTopX: IGenericAggregateResponse) {
  let ytdTopX = 0;
  for (const item of dataTopX.aggregates ? dataTopX.aggregates : []) {
    if (
      item.dimensionAttributeValues[SCAttributes.SC_CLIENT_LEID] != null &&
      !isNaN(item.indicatorKpiValues.sc_ytd)
    ) {
      ytdTopX += item.indicatorKpiValues.sc_ytd;
    }
  }
  return Number(ytdTopX.toFixed(0)) / 1000;
}

function calculateSCForAll(dataAll: IGenericAggregateResponse) {
  let totalSc = 0;
  if (
    dataAll.aggregates &&
    dataAll.aggregates.length === 1 &&
    dataAll.aggregates[0] &&
    !isNaN(dataAll.aggregates[0].indicatorKpiValues.sc_ytd)
  ) {
    totalSc = dataAll.aggregates[0].indicatorKpiValues.sc_ytd;
  }
  return Number(totalSc.toFixed(0)) / 1000;
}
